require('./lbaHotelReview.scss');

const $inject = [];
const lbaHotelReview = function () {
  return {
    restrict: 'A',
    scope:{
    },
    bindToController: true,
    controller: 'lbaHotelReviewCtrl',
    controllerAs: 'vm',
    template: require('./lbaHotelReview.html')
  }
};

lbaHotelReview.$inject = $inject;

export default lbaHotelReview;


// WEBPACK FOOTER //
// ./src/components/lbaHotelReview/lbaHotelReviewDir.js